import AbstractUser from "./AbstractUser";

export default class LayoutSpecialist extends AbstractUser {
  get role(): string {
    return 'layout-expert';
  }
}
